const SCRIPT_ATTR = 'data-ips-recaptcha';
const hasRender = (g: any) => !!(g && typeof g.render === 'function');

export const loadRecaptcha = (version: 'v2' | 'v3', siteKey: string) => {
  if (!siteKey) return Promise.reject(new Error('Missing recaptcha site key'));

  const existing = (window as any).grecaptcha;
  if (existing) {
    // Für v2 nur auf render prüfen, v3 braucht keine render-Funktion.
    if (version === 'v2' && hasRender(existing)) {
      return Promise.resolve(existing);
    }
    if (version === 'v3') {
      return Promise.resolve(existing);
    }
  }

  return new Promise<any>((resolve, reject) => {
    let timeoutHandle: number | null = null;

    const finish = () => {
      const g = (window as any).grecaptcha;
      if (hasRender(g)) {
        resolve(g);
        return;
      }
      reject(new Error('Recaptcha loaded without render function'));
    };

    const attachReady = () => {
      const g = (window as any).grecaptcha;
      if (!g) return reject(new Error('Recaptcha global missing after load'));
      if (version === 'v2') {
        if (hasRender(g)) return resolve(g);
        if (typeof g.ready === 'function') {
          g.ready(finish);
        } else {
          finish();
        }
      } else {
        // v3: render nicht erforderlich, ready ausreichend.
        if (typeof g.ready === 'function') {
          g.ready(() => resolve(g));
        } else {
          resolve(g);
        }
      }
    };

    // Script ggf. nur einmal hinzufügen.
    const existingScript = document.querySelector(`script[${SCRIPT_ATTR}="1"]`);
    if (existingScript) {
      attachReady();
    } else {
      const script = document.createElement('script');
      script.setAttribute(SCRIPT_ATTR, '1');
      script.src =
        version === 'v2'
          ? 'https://www.google.com/recaptcha/api.js'
          : `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
      script.async = true;
      script.defer = true;
      script.onload = attachReady;
      script.onerror = () => reject(new Error('Failed to load recaptcha script'));
      document.head.appendChild(script);
    }

    // Safety-Timeout, falls Google nicht antwortet.
    timeoutHandle = window.setTimeout(() => {
      reject(new Error('Recaptcha load timeout'));
    }, 15000);

    // Aufräumen bei Erfolg/Fehler.
    const clear = () => {
      if (timeoutHandle !== null) {
        clearTimeout(timeoutHandle);
      }
    };
    const origResolve = resolve;
    const origReject = reject;
    resolve = (v: any) => {
      clear();
      origResolve(v);
    };
    reject = (e: any) => {
      clear();
      origReject(e);
    };
  });
};
